module.exports = __webpack_public_path__ + "static/media/copyright.a0dce194.png";